<template>
  <div class="cr-flex cr-flex-col cr-align-center gap-2">
    <CraftyCopilotImage
      height="64px"
      width="64px"
    />
    <div class="greeting gap-1 cr-flex cr-flex-col cr-justify-end cr-align-center">
      <span class="greeting__text cr-flex cr-justify-center title-m-medium">
        {{ greeting }}
      </span>
      <div class="greeting__compliment body-m-regular cr-font-poppins">
        <ClientHomePageCompliments />
      </div>
    </div>
  </div>
</template>

<script>
import ClientHomePageCompliments from '../views/ClientHomePageCompliments.vue'
import CraftyCopilotImage from './CraftyCopilotImage.vue'

export default {
  name: 'ClientHomePageGreeting',
  components: {
    ClientHomePageCompliments,
    CraftyCopilotImage,
  },
  props: {
    externalUserFullName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentTimeHours: new Date().getHours(),
    }
  },
  computed: {
    firstName() {
      return this.externalUserFullName.split(' ')[0] ?? ''
    },
    greeting() {
      const hours = this.currentTimeHours
      if (hours >= 3 && hours < 12) {
        return `Good morning ${this.firstName} ☕️`
      } else if (hours >= 12 && hours < 17) {
        return `Good afternoon ${this.firstName} 🥤`
      } else {
        return `Good evening ${this.firstName} 🍺`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.greeting {
  &__text, &__compliment {
    text-align: center;
  }
}
</style>
